import {useEffect, useState } from "react";

import io from "socket.io-client";
import {v4 as uuidv4} from "uuid";
// import Live2DLipSync from "@features/student/practice/Live2DLipSync";
import axios from "axios";
import LoadVideo from "@features/student/practice/LoadVideo";

type Props = {}

const SOCKET_SERVER_URL = process.env.SOCKET_SERVER_URL;
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

export default function LoadingH5pAiEvent({}: Props) {
    const [iframeSrc, setIframeSrc] = useState("");
    const [audioUrl, setAudioUrl] = useState("");
    const [videoUrl, setVideoUrl] = useState("");

    useEffect(() => {
        const generatedSessionId = uuidv4();

        const iframeUrl = `https://lms.vmb.edu.vn/xblock/block-v1:VMB+OE0000+2024_10+type@vertical+block@0efc46897ec8415f96e9ec3a688f05e7?exam_access=&recheck_access=1&show_bookmark=0&show_title=0&view=student_view&vmb-app-session-id=${generatedSessionId}`;
        setIframeSrc(iframeUrl);

        const socketConnection = io(SOCKET_SERVER_URL);

        socketConnection.on("connect", () => {
    
            socketConnection.on("joined_group", (message) => {
                console.log("joined_group: Message from room:", message);
                console.log(`Site connected to Socket.IO server. Joined group with sessionId: ${generatedSessionId}`);
            });

            socketConnection.on("h5p_event", async (message) => {
                console.log("Site H5p_event:", message);
                const {data, type, slide} = message;

                if (type === "custom" && data && data.type === "textToSpeech") {
                    const {audio_url} = await fetchTTS(data.content);
                    setAudioUrl(audio_url);

                    if (slide && slide.video_url) {
                        setVideoUrl(slide.video_url);
                    } else {
                        setVideoUrl('');
                    }
                }
            });

            socketConnection.emit("join_group", {sessionId: generatedSessionId});
        });

        return () => {
            socketConnection.disconnect();
        };
    }, []);

    const fetchTTS = async (text: any) => {
        try {
            const response = await axios.get(`${REACT_APP_API_URL}/api/speech/tts`, {
                params: {text},
            });
            console.log("TTS Response:", response.data.audio_url);
            return response.data;
        } catch (error) {
            console.error("Error fetching TTS:", error);
            throw error;
        }
    };

    const answerChat = async (text: string): Promise<string> => {
        try {
            let response = await axios.get(`${REACT_APP_API_URL}/api/speech/synthesize`, {
                params: {prompt: text},
            });

            console.log("Synthesize Response:", response.data.synthesized_text);
            if (response.data.synthesized_text) {
                response = await axios.get(`${REACT_APP_API_URL}/api/speech/tts`, {
                    params: {text: response.data.synthesized_text},
                });

                console.log("TTS Response:", response.data.audio_url);
                if (response.data.audio_url) {
                    setAudioUrl(response.data.audio_url);
                }
            }
        } catch (error) {
            console.error("Error fetching TTS:", error);
            throw error;
        }

        return "Done";
    };

    return (
        <div>
            <iframe
                src={iframeSrc}
                scrolling="no"
                allowFullScreen={true}
                className="d-flex w-full"
                height={1000}
                style={{minHeight: '60rem'}}
            ></iframe>
            <LoadVideo
                url={videoUrl}
                className={'fixed bottom-4 left-1 w-[220px] h-[380px] bg-gray-800 p-2 rounded-lg shadow-lg'}
                />
        </div>
    )
}